import store from "../../store/index";
const AuthStore = store.state.auth; // !!! AuthStore.user IS NOT AVAILABLE HERE, THAT IS WHY WE GET AUTHSTORE ONLY
import BadgeAPI from "./BadgeAPI";
import BadgeUtilities from "./BadgeUtilities";
import { BadgeStore } from "../ELYXStore";

const BadgeMethods = {
  /**
   * @NB Note that this is also use on the PROFILE, meaning it could also
   * get the badges for ANOTHER user, which is why we specify the UID here
   * and don't take it from the AuthStore.
   */
  async getAllUserBadges() {
    try {
      const response = await BadgeAPI.getAllUserBadges(AuthStore.user._id);
      if (!response || !response.success) {
        throw new Error("@BadgeMethods.getAllUserBadges: Failed to get user badges.");
      }

      const badges = response.data;
      if (badges && badges.length) {
        const badgesData = BadgeUtilities.getBadgesByBadgeNr(badges);
        BadgeStore.methods.setUserBadges(badgesData);
      }
    } catch (error) {
      console.error("@BadgeMethods.getAllUserBadges: ", error);
    }
  },

  async getAllProfileBadges(UID) {
    try {
      const response = await BadgeAPI.getAllUserBadges(UID);
      if (!response || !response.success) {
        throw new Error("@BadgeMethods.getAllUserBadges: Failed to get user badges.");
      }

      /* Set any badges needing to be awarded */
      const badges = response.data;
      if (badges && badges.length) {
        const badgesData = BadgeUtilities.getBadgesByBadgeNr(badges);
        BadgeStore.methods.setUserBadges(badgesData);
      }
    } catch (error) {
      console.error("@BadgeMethods.getAllProfileBadges: ", error);
    }
  },

  /** Gets or refreshses */
  async getUserUnawardedBadges() {
    try {
      const response = await BadgeAPI.getUserUnawardedBadges(AuthStore.user._id);
      if (!response || !response.success) {
        throw new Error("@BadgeMethods.getUserUnawardedBadges: Failed to get user unawarded badges.");
      }

      /* Set any badges needing to be awarded */
      const badges = response.data;
      if (badges && badges.length) {
        const badgesData = BadgeUtilities.getBadgesByBadgeNr(badges);
        BadgeStore.methods.setUnawardedBadges(badgesData);
      }
    } catch (error) {
      console.error("@BadgeMethods.getUserUnawardedBadges: ", error);
    }
  },

  clearUnawardedBadges() {
    BadgeStore.methods.clearUnawardedBadges();
  },

  async confirmGotBadge(badgeNr) {
    try {
      const response = await BadgeAPI.confirmGotBadge(AuthStore.user._id, badgeNr);
      if (!response || !response.success) {
        throw new Error("@BadgeMethods.confirmGotBadge: Failed to confirm got badge.");
      }
    } catch (error) {
      console.error("@BadgeMethods.confirmGotBadge: ", error);
    }
  },
};

export default BadgeMethods;
